(function () {
  'use strict';

  if (window.LeeStaffordInstagramFeed) {
    window.LeeStaffordInstagramFeed.initAll();
    return;
  }

  var DEFAULT_ENDPOINT = 'https://api.leestafford.com/instagram/';
  var REQUEST_TIMEOUT = 10000;

  function safeUrl(value, baseUrl, instagramOnly) {
    try {
      var url = new URL(value, baseUrl);
      if (url.protocol !== 'https:') return null;
      if (
        instagramOnly &&
        url.hostname !== 'instagram.com' &&
        url.hostname !== 'www.instagram.com'
      ) {
        return null;
      }
      return url.href;
    } catch (error) {
      return null;
    }
  }

  function imageVariants(item, endpoint) {
    if (!item || !Array.isArray(item.images)) return [];

    var endpointOrigin;
    try {
      endpointOrigin = new URL(endpoint).origin;
    } catch (error) {
      return [];
    }

    return item.images
      .map(function (image) {
        var url = image && safeUrl(image.url, endpoint, false);
        var width = image && Number(image.width);
        var height = image && Number(image.height);

        if (!url || new URL(url).origin !== endpointOrigin || !width || !height) return null;
        return { url: url, width: width, height: height };
      })
      .filter(Boolean)
      .sort(function (left, right) {
        return left.width - right.width;
      });
  }

  function imageAlt(item) {
    var caption = typeof item.caption === 'string' ? item.caption.trim() : '';
    if (caption) return caption.slice(0, 240);

    var username = typeof item.username === 'string' ? item.username.trim() : '';
    return username ? 'Instagram post by @' + username : 'Instagram post';
  }

  function createSlide(item, endpoint) {
    var permalink = item && safeUrl(item.permalink, endpoint, true);
    var variants = imageVariants(item, endpoint);
    if (!permalink || variants.length === 0) return null;

    var largest = variants[variants.length - 1];
    var wrapper = document.createElement('div');
    var link = document.createElement('a');
    var figure = document.createElement('figure');
    var image = document.createElement('img');

    wrapper.className = 'item';
    link.href = permalink;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.style.aspectRatio = '1 / 1';
    link.setAttribute('aria-label', 'View this post on Instagram');

    image.src = largest.url;
    image.srcset = variants
      .map(function (variant) {
        return variant.url + ' ' + variant.width + 'w';
      })
      .join(', ');
    image.sizes = '(max-width: 480px) 57vw, (max-width: 768px) 35vw, 21vw';
    image.width = largest.width;
    image.height = largest.height;
    image.alt = imageAlt(item);
    image.loading = 'lazy';
    image.decoding = 'async';

    figure.appendChild(image);
    link.appendChild(figure);
    wrapper.appendChild(link);
    return wrapper;
  }

  function sliderOptions(container) {
    return {
      container: container,
      items: 1.75,
      nav: false,
      controls: true,
      controlsText: [
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44.79 45.18" aria-hidden="true"><polyline fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" points="43.29 22.54 1.74 22.54 21.74 1.5 1.5 22.54 21.74 43.68"/></svg>',
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44.79 45.18" aria-hidden="true"><polyline fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" points="1.5 22.63 43.05 22.63 23.05 43.68 43.29 22.63 23.05 1.5"/></svg>',
      ],
      mouseDrag: true,
      loop: true,
      autoplay: false,
      gutter: 20,
      center: true,
      startIndex: Math.floor(container.children.length / 2),
      responsive: {
        481: { items: 2.85, gutter: 24 },
        769: { items: 4.8, gutter: 28 },
      },
    };
  }

  function initialiseSlider(container) {
    if (typeof window.tns !== 'function' || container.children.length === 0) {
      throw new Error('Tiny Slider is not available.');
    }

    var slider = window.tns(sliderOptions(container));
    window.instagramSlider = slider;
    window.instagramSliders = window.instagramSliders || [];
    window.instagramSliders.push(slider);
  }

  function requestFeed(endpoint) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timeout = controller
      ? window.setTimeout(function () {
          controller.abort();
        }, REQUEST_TIMEOUT)
      : null;

    return window
      .fetch(endpoint, {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit',
        headers: { Accept: 'application/json' },
        signal: controller ? controller.signal : undefined,
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Instagram feed returned HTTP ' + response.status + '.');
        return response.json();
      })
      .finally(function () {
        if (timeout !== null) window.clearTimeout(timeout);
      });
  }

  function load(container) {
    var state = container.getAttribute('data-instagram-feed-state');
    if (state === 'loading' || state === 'loaded') return;

    var endpoint = safeUrl(
      container.getAttribute('data-endpoint') || DEFAULT_ENDPOINT,
      DEFAULT_ENDPOINT,
      false
    );
    var limit = parseInt(container.getAttribute('data-limit') || '16', 10);
    if (!endpoint) return;
    if (!Number.isFinite(limit) || limit < 1) limit = 16;

    container.setAttribute('data-instagram-feed-state', 'loading');

    requestFeed(endpoint)
      .then(function (feed) {
        if (!feed || !Array.isArray(feed.items) || feed.items.length === 0) {
          throw new Error('Instagram feed contains no items.');
        }

        var fragment = document.createDocumentFragment();
        feed.items.slice(0, Math.max(1, limit)).forEach(function (item) {
          var slide = createSlide(item, endpoint);
          if (slide) fragment.appendChild(slide);
        });

        if (fragment.childNodes.length === 0) {
          throw new Error('Instagram feed contains no usable images.');
        }

        container.replaceChildren(fragment);
        initialiseSlider(container);
        container.setAttribute('data-instagram-feed-state', 'loaded');
      })
      .catch(function (error) {
        container.setAttribute('data-instagram-feed-state', 'error');
        if (window.console && typeof window.console.error === 'function') {
          window.console.error('Instagram feed error:', error);
        }
      });
  }

  function initAll(root) {
    var scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    scope.querySelectorAll('[data-instagram-feed]').forEach(load);
  }

  window.LeeStaffordInstagramFeed = {
    initAll: initAll,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
